// Стиль слоя комет «Траекторий по HSI». Геометрию кадра считает
// models/hsiCometFrame.ts, цвет — та же inferno-шкала, что у статичных усиков
// (map/hsiDrift.ts): комета остаётся носителем HSI, а не белой засечкой.

import { OVERLAY_PREFIX } from './layerOrder'

export const HSI_COMET_PREFIX = OVERLAY_PREFIX + 'hsicomet-'

/** Толщина кометы относительно базовой линии. Значение выбрано владельцем на демо. */
export const COMET_WIDTH_SCALE = 0.5

export type CometPart = 'body' | 'tip'

export function hsiCometSourceId(key: string): string {
  return `${HSI_COMET_PREFIX}src-${key}`
}
export function hsiCometLayerId(key: string, part: CometPart): string {
  return `${HSI_COMET_PREFIX}${key}-${part}`
}

/** Ширина кометы по зуму (база × COMET_WIDTH_SCALE). */
export function hsiCometWidthExpr() {
  const s = COMET_WIDTH_SCALE
  return ['interpolate', ['linear'], ['zoom'], 3, 1.4 * s, 7, 2.6 * s, 12, 4.4 * s]
}

/** Головное звено кометы — отдельным белым слоем поверх тела. */
export const TIP_FILTER = ['==', ['get', 'tip'], 1]
